import { useEffect } from "react";

export default function useScrollReveal() {
    useEffect(() => {
        // Honour the user's preference for reduced motion: simply mark every
        // reveal element as visible immediately and skip observers.
        const prefersReducedMotion = window.matchMedia(
            "(prefers-reduced-motion: reduce)",
        ).matches;
        if (prefersReducedMotion) {
            document
                .querySelectorAll(".reveal, .reveal-photo")
                .forEach((el) => el.classList.add("in"));
            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("in");
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.1, rootMargin: "0px 0px -40px 0px" },
        );

        const observeAll = () => {
            document
                .querySelectorAll(".reveal:not(.in), .reveal-photo:not(.in)")
                .forEach((el) => observer.observe(el));
        };

        observeAll();

        // Listen for a custom event the app dispatches when async data is
        // loaded — avoids attaching a global MutationObserver that constantly
        // scans the entire DOM (which was causing micro-stutters).
        const onContentReady = () => observeAll();
        window.addEventListener("content:ready", onContentReady);

        return () => {
            observer.disconnect();
            window.removeEventListener("content:ready", onContentReady);
        };
    }, []);
}
